/* eslint-disable no-unused-expressions */
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface BaseAlertDialogProps {
  open: boolean;
  onClose?: (status: string) => () => void;
  title: string;
  message: string;
  activateYes?: boolean;
  activeNo?: boolean;
}

export function BaseAlertDialog({
  open,
  onClose,
  title,
  message,
  activateYes = false,
  activeNo = true,
}: BaseAlertDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose?.('no')}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {activateYes && <Button onClick={onClose?.('yes')}> 네 </Button>}
        {activeNo && (
          <Button onClick={onClose?.('no')} autoFocus>
            {' '}
            아니오{' '}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  onClose: (answer: string) => () => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose('close')}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose('confirm')}>확인</Button>
        <Button onClick={onClose('cancel')}>취소</Button>
      </DialogActions>
    </Dialog>
  );
}
